import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-social-facebook",
  "use": "icon-social-facebook-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-social-facebook\">\r\n  <path id=\"icon-social-facebook_iconmonstr-facebook-3\" d=\"M31.667,0H8.333A8.334,8.334,0,0,0,0,8.333V31.667A8.334,8.334,0,0,0,8.333,40H31.667A8.333,8.333,0,0,0,40,31.667V8.333A8.333,8.333,0,0,0,31.667,0Zm-5,11.667H23.46c-1.025,0-1.793.42-1.793,1.482V15h5l-.4,5h-4.6V33.333h-5V20H13.333V15h3.333V11.8c0-3.37,1.773-5.128,5.768-5.128h4.232Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol